import { createContext, useContext, useMemo, useState, useEffect } from 'react'

const CartCtx = createContext(null)

export function CartProvider({ children }) {
    const [items, setItems] = useState([])


    const add = (products) => {
        setItems(prev => {
            return products.map(product => {
                const variant = product.Variants?.[0] ?? null; // pick default variant
                const key = `${product.id}:${variant?.ProductVariantId ?? 'base'}`;

                // check if this product already exists in prev
                const existing = prev.find(i => i.key === key);
                const primaryImage =
                    product.Images?.find(img => img.IsPrimary)?.ImageUrl ||
                    product.Images?.[0]?.ImageUrl ||
                    null;

                return {
                    key,
                    id: product.id,
                    ProductVariantId: variant?.ProductVariantId,
                    Name: product.Name,
                    VariantSKU: variant?.VariantSKU,
                    PriceUSD: variant?.PriceUSD ?? 0,
                    qty: existing ? existing.qty : 1,
                    ImageUrl: primaryImage,
                    ...product
                };
            });
        });
    };


    const inc = (key) => setItems(prev => prev.map(i => i.key === key ? { ...i, qty: i.qty + 1 } : i))
    const dec = (key) => setItems(prev => prev.flatMap(i => i.key === key ? (i.qty > 1 ? [{ ...i, qty: i.qty - 1 }] : []) : [i]))
    const remove = (key) => setItems(prev => prev.filter(i => i.key != key))
    const clear = () => setItems([]);

    const qtyOf = (id, variantId) => {
        const key = `${id}:${variantId ?? 'base'}`
        const found = items.find(i => i.key === key)
        return found?.qty ?? 0
    }

    const totals = useMemo(() => {
        const subtotal = items.reduce((sum, i) => sum + i.PriceUSD * i.qty, 0)
        const shipping = items.length ? 5 : 0
        const tax = 0
        return { subtotal, shipping, tax, grand: subtotal + shipping + tax }
    }, [items])

    return (
        <CartCtx.Provider value={{ items, add, inc, dec, remove, qtyOf, totals, clear }}>
            {children}
        </CartCtx.Provider>
    )
}

export function useCart() {
    const ctx = useContext(CartCtx)
    if (!ctx) throw new Error('useCart must be used inside CartProvider')
    return ctx
}
